import { getVariantCache } from '../experiments/cache/variantCache';

import Analytics from './analytics';

export const trackValueChanges = (
  name: string,
  oldValue: string | number | undefined | null,
  newValue: string | number | undefined | null,
  event: {
    category: string;
    action: string;
    property?: string;
    value?: number;
  }
): void => {
  if (oldValue !== newValue) {
    if (newValue) {
      Analytics.trackSnowplowEvent({
        ...event,
        label: `change_${name}`,
      });
    } else {
      Analytics.trackSnowplowEvent({
        ...event,
        label: `remove_${name}`,
      });
    }
  }
};

/**
 * Experiments context is used to keep track of the variants the current user is in for Amplitude Experiments
 */
export const attachExperimentsContext = (
  context: null | Array<unknown>
): null | Array<unknown> => {
  const experiments = getVariantCache();

  if (!Object.keys(experiments).length || !context) {
    return context;
  }

  const newContext = [
    ...context,
    ...Object.entries(experiments)
      .map(([key, variant]) => ({
        schema: 'iglu:com.wetransfer/experiment_context/jsonschema/1-0-0',
        data: {
          key: key.toString(),
          variant: variant?.value?.toString(),
        },
      }))
      .filter((el) => el.data.variant), // This will filter variants that are undefined in localStorage
  ];

  return newContext;
};

/**
 * Filter out undefined properties from an object
 *
 * @example ```
 *  const obj = {
 *    prop1: undefined,
 *    prop2: 0,
 *    prop3: 'some string'
 *  }
 *
 * console.log(filterUndefinedProperties(obj))
 * > { prop2: 0, prop3: 'some string' }
 * ```
 */
export const filterUndefinedProperties = <T>(properties: T): Partial<T> =>
  Object.entries(properties).reduce<Partial<T>>((props, [key, val]) => {
    if (typeof val !== 'undefined') {
      return {
        ...props,
        [key]: val,
      };
    }

    return props;
  }, {});
